import { getLocale } from '../utils/env/getLocale';

const locale = getLocale();

const linkPrefix = `https://support.wix.com/${locale}/widget/cb6480f3-768b-4737-ab8f-10fe2e4fa2ab/article/`;
const articlePrefix = `https://support.wix.com/${locale}/article/`;

export const HELP_LINKS = {
  MAIN: `${linkPrefix}fd29e7ce-e3f9-4855-b11a-e0129eb3bcca`,
  WIX_APP: `${linkPrefix}4d5439b4-6a99-46a8-aef2-94d029f4ea41`,
  UPLOAD_REQUIREMENTS: `${linkPrefix}739a2868-2cd6-43ec-9fe3-f7861a64cc72`,
  CONTRIBUTORS: `${linkPrefix}9926e9ed-ba83-483b-8377-555a935b987c`,
  WIX_COM: 'https://www.wix.com/',
  IMPORT_FILES: `${linkPrefix}5a9eaeb2-5acb-4ee8-ac92-21e38895e64d`,
  BOARDS: `${linkPrefix}960df6df-6f4b-4f24-a73c-02c2181ec017`,
  LEARN_MORE_TRASH: `${linkPrefix}156e4366-f4bb-4f12-9ef2-8d232d2ae4ea`,
  LEARN_MORE_PURCHASED: `${linkPrefix}f3b22b5a-ce61-459b-88f8-db10815f823e`,
  LEARN_MORE_VISITOR_UPLOADS: `${linkPrefix}96f8653f-c0a0-4c15-b9c1-0118724492f3`,
  USER_FEEDBACK: `${linkPrefix}815e983c-8b86-452b-9ee3-cca3a2d2fc76`,
  LEARN_MORE_UPLOADING_CONTRIBUTORS_HINT: `${articlePrefix}about-contributor-roles-permissions`,
  LEARN_MORE_SUPPORTED_TYPES_AND_SIZES: `${linkPrefix}739a2868-2cd6-43ec-9fe3-f7861a64cc72`,
  LEARN_MORE_FONTS_UPLOAD: `${articlePrefix}uploading-and-using-your-own-fonts`,
  LEARN_MORE_STORAGE_MEDIA: `https://support.wix.com/${locale}/article/wix-media-managing-your-storage-3724756`,
  UNSPLASH_TERMS: 'https://unsplash.com/terms',
  LEARN_MORE_UNSPLASH: `${linkPrefix}f9707884-e8e9-420a-9540-a15b72feea65`,
  LEARN_MORE_FILES_IMPORTER: `${linkPrefix}43876f1a-b1c8-428c-bb3f-a9d443f9f37d`,
  DELETE_FLOW_READ_MORE: `${linkPrefix}deleting-media-files-from-your-media-manager`,
  LEARN_MORE_OOPS_SCREEN: `${linkPrefix}media-upload-issues`,
  UPLOAD_VIDEO_TROUBLESHOOTING: `${linkPrefix}2dbfe42a-cf8b-479d-89d1-4b9863b98c95`,
  UPLOAD_AUDIO_TROUBLESHOOTING: `${linkPrefix}702dce0c-d6dc-4d10-a659-fc8ce67b6c18`,
  UPLOAD_IMAGE_TROUBLESHOOTING: `${linkPrefix}5a780ef9-2ef4-4a22-8d9d-5446e8cd39ed`,
  UPLOAD_GENERAL: `${linkPrefix}818bc2c8-2c70-4e24-aa4f-9f5cbde29de2`,
  UPLOAD_VECTOR_ART: `${linkPrefix}81174f6c-3230-4123-bc4d-dad78e837c58`,
  RESUME_UPLOAD: `${linkPrefix}wix-media-resuming-the-upload-of-large-video-files-in-the-wix-media-manager`,
};
